import {Value} from "./value";
import {UnitType} from "./unitType";

export class Millimeters extends Value {
    constructor(value: number) {
        super(value, UnitType.MM);
    }
}
